import { defineComponent as _defineComponent } from 'vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import { ref, watch } from 'vue';
    import { useCustomerStore } from '@/store/customer';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessDetailsModal',
  props: {
    open: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        open: boolean;
    }

    const customerStore = useCustomerStore();

    

    const modalActive = ref(false);

    watch(
        () => props.open,
        (value) => {
            modalActive.value = value;
        },
    );

    function finish() {
        customerStore.dispatchCustomerAddOrUpdate();
        modalActive.value = false;
    }

    function cancel() {
        customerStore.customer.is_company = false;
    }

return { __sfc: true,customerStore, props, modalActive, finish, cancel, ValidationObserver, ValidationProvider }
}

})